import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IRequestDto {
    esiaCode: string,
    withValidation: boolean,
}
export interface IResponseDto {
    authUrl: string,
}

/*
* Обновляет персональные данные в биллинге (Запрашивает ПД в esia Госуслуги)
* https://master.esign.sandbox.d2c.r-one.io/docs/#/Esia/EsiaController_updatePersonalData
*/
export const personalData = (requestDto: IRequestDto): IRequest => ({
    uri: '/api/v1/esia/personal-data',
    method: 'PATCH',
    withProvider: true,
    withAuth: true,
    body: JSON.stringify(requestDto),
});
